import render from './render'

/**
 * Состояния правила блока проверки.
 *
 * @type {{ empty: string, valid: string, invalid: string }}
 */
export const validationInfoStates = {
  empty: 'empty',
  valid: 'valid',
  invalid: 'invalid'
}

/**
 * Блок проверки заполнения формы: группы правил с иконкой состояния
 * каждого правила, соседние группы разделены `g-divider`. При пустом
 * списке групп выводится содержимое слота по умолчанию.
 */
export default {
  name: 'ValidationInfo',

  props: {
    /**
     * Группы правил в порядке вывода.
     * `title` - необязательный заголовок группы, `rules` - правила группы.
     * У правила `text` - текст правила, `state` - одно из `validationInfoStates`,
     * `html` - признак вывода текста как HTML.
     *
     * @type {{ title?: string, rules: { text: string, state: string, html?: boolean }[] }[]}
     * @default []
     */
    value: {
      type: Array,
      default: () => {
        return []
      }
    },

    /**
     * Признак подсветки блока фоном ошибки, если хотя бы одно правило нарушено.
     *
     * @type {boolean}
     * @default false
     */
    highlightInvalid: Boolean
  },

  computed: {
    /**
     * Признак нарушения хотя бы одного правила.
     *
     * @returns {boolean}
     */
    hasInvalidRule() {
      return this.value.some(({ rules }) => {
        return rules.some(({ state }) => {
          return state === validationInfoStates.invalid
        })
      })
    }
  },

  render
}
